/**
 * Provider Form Design Tokens
 *
 * Scope:
 * - Only provider flow screens/components.
 * - Do not use for RH screens (kept as-is by product decision).
 */

/**
 * Base input style used across provider authentication/registration forms.
 * Visual spec:
 * - Rounded box
 * - Soft gray background
 * - Neutral placeholder
 * - Blue border accent on focus
 */
export const PROVIDER_INPUT_CLASS =
  "w-full px-4 py-2.5 border-0 rounded-lg bg-[#F6F9FB] focus:bg-[#F7F9FC] focus:border-[#315FB9] focus:ring-0 transition-all duration-200 text-sm text-gray-900 placeholder-gray-400";
